<div class="bg-bg-base">
  <section class="relative overflow-hidden py-10">

    <div class="pointer-events-none absolute inset-0 overflow-hidden">
      <div class="absolute -right-40 -top-40 h-80 w-80 rounded-full bg-primary/5 blur-3xl"></div>
      <div class="absolute -bottom-40 -left-40 h-80 w-80 rounded-full bg-primary-deep/10 blur-3xl"></div>
    </div>

    <div class="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

      <div class="mb-20 text-center" data-aos="fade-up">
        <h2
          class="mb-4 bg-primary bg-clip-text text-3xl font-bold text-transparent md:text-4xl leading-tight">
          {{ 'home.howItWorks.title' | translate }}
        </h2>
        <p class="mx-auto max-w-2xl text-base md:text-lg text-text-secondary">
          {{ 'home.howItWorks.subtitle' | translate }}
        </p>
      </div>

      <div class="grid grid-cols-1 gap-12 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6">
        @for (step of steps; track step.id; let i = $index) {
        <app-step-card [step]="step" [showConnector]="i < steps.length - 1" data-aos="fade-up"
          [attr.data-aos-delay]="i * 150" class="w-full">
        </app-step-card>
        }
      </div>

      <div class="mt-16 text-center" data-aos="fade-up" data-aos-delay="600">
        <button (click)="onStartJourney()"
          class="btn btn-primary px-7 py-3.5 text-base shadow-primary-glow">
          <span>{{ 'home.howItWorks.cta' | translate }}</span>
          <i class="fas fa-arrow-right text-sm transition-transform duration-300 rtl:rotate-180"></i>
        </button>
      </div>

      <app-register-pop [isOpen]="showRegisterPopup" (close)="closeRegisterPopup()"></app-register-pop>

    </div>
  </section>
</div>